import { Card, Skeleton, cn } from "ui";

type SettingsFormSkeletonSection = {
  /** Number of label/description + input rows in the section. */
  rows: number;
  /** Render a section heading above the rows. */
  withTitle?: boolean;
};

type SettingsFormSkeletonProps = {
  /** One titled/untitled group of rows per entry. Rendered inside a single card. */
  sections?: SettingsFormSkeletonSection[];
  /** Wrap the sections in a card. Set false when the page already provides one. */
  withCard?: boolean;
  className?: string;
};

export const SettingsFormSkeleton = ({
  sections = [{ rows: 4 }],
  withCard = true,
  className,
}: SettingsFormSkeletonProps) => {
  const content = sections.map((section, sectionIndex) => (
    <div
      key={sectionIndex}
      className={cn(
        "flex flex-col",
        sectionIndex > 0 && "border-t border-foundations-subtle pt-8",
        sectionIndex < sections.length - 1 && "pb-8"
      )}
    >
      {section.withTitle && <Skeleton className="mb-6 h-5 w-40" />}

      <div className="flex flex-col gap-8">
        {Array.from({ length: section.rows }).map((_, rowIndex) => (
          <div
            key={rowIndex}
            className="flex items-center justify-between gap-4"
          >
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-3 w-56" />
            </div>
            <Skeleton className="h-10 w-1/3 rounded-md" />
          </div>
        ))}
      </div>
    </div>
  ));

  if (!withCard) return <>{content}</>;

  return (
    <Card disableHover className={cn("flex flex-col", className)}>
      {content}
    </Card>
  );
};
